import { axios } from '@/utils/axios';
import type { BlockchainApiResponse, BlockchainDocument, BlockchainDocumentListResponse, BlockchainDocumentStatus, BlockchainVerificationResult } from '@/types/blockchainDocuments';

const base = '/api/blockchain-documents';

export const getBlockchainDocuments = (params: {
  source?: 'all' | 'manual' | 'deal';
  status?: 'all' | BlockchainDocumentStatus;
  archived?: 0 | 1;
  q?: string;
  page?: number;
  per_page?: number;
}) => axios.get<BlockchainApiResponse<BlockchainDocumentListResponse>>(base, { params });

export const uploadBlockchainDocument = (file: File, idempotencyKey: string) => {
  const form = new FormData();
  form.append('file', file);
  return axios.post<BlockchainApiResponse<{ document: BlockchainDocument; reused: boolean }>>(base, form, {
    headers: { 'Content-Type': 'multipart/form-data', 'Idempotency-Key': idempotencyKey },
  });
};

export const downloadBlockchainDocument = (id: string) => axios.get<Blob>(`${base}/${id}/download`, { responseType: 'blob' });
export const verifyBlockchainDocument = (id: string, file: File) => {
  const form = new FormData();
  form.append('file', file);
  return axios.post<BlockchainApiResponse<BlockchainVerificationResult>>(`${base}/${id}/verify`, form, { headers: { 'Content-Type': 'multipart/form-data' } });
};
export const archiveBlockchainDocument = (id: string) => axios.patch<BlockchainApiResponse<BlockchainDocument>>(`${base}/${id}/archive`);
export const unarchiveBlockchainDocument = (id: string) => axios.patch<BlockchainApiResponse<BlockchainDocument>>(`${base}/${id}/unarchive`);
export const retryBlockchainDocument = (id: string) => axios.post<BlockchainApiResponse<BlockchainDocument>>(`${base}/${id}/retry`);
